import { submitIntakeFormPetThunk } from 'actions/intakeForm/IntakeFormActions';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { PetForm } from 'components/Pet/Form/PetForm';
import { Button } from 'components/UI/Button/Button';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIntakeFormPetQuestions } from 'reducers/marketplace/MarketplaceSelectors';
import { Pet } from 'types/Pet';

export const IntakeFormAddPet: React.FC = () => {
    const dispatch = useDispatch();
    const questions = useSelector(getIntakeFormPetQuestions);

    const formRef = React.useRef<HTMLFormElement>(null);

    const [isValid, setIsValid] = React.useState(false);

    const tiggerSubmitHandler = () => {
        formRef.current?.submit();
    };

    const submitHandler = (pet: Pet) => {
        dispatch(submitIntakeFormPetThunk(pet));
    };

    return (
        <LeftColumn
            footer={
                <Button fullWidth disabled={!isValid} onClick={tiggerSubmitHandler}>
                    Continue
                </Button>
            }
        >
            <h1 className="h1 underlined">Add pet</h1>

            <PetForm
                ref={formRef}
                questions={questions}
                onChange={setIsValid}
                onSubmit={submitHandler}
            />
        </LeftColumn>
    );
};
